import { render, staticRenderFns } from "./MyTasksView.vue?vue&type=template&id=6b7b4878&scoped=true&"
import script from "./MyTasksView.vue?vue&type=script&lang=js&"
export * from "./MyTasksView.vue?vue&type=script&lang=js&"
import style0 from "./MyTasksView.vue?vue&type=style&index=0&id=6b7b4878&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b4878",
  null
  
)

export default component.exports